import { useDeviceStore } from '~/store/device';

export default defineNuxtPlugin((nuxtApp: any) => {
  const $device = useDevice();
  const deviceStore = useDeviceStore(nuxtApp.$pinia);
  deviceStore.setDevice($device);
});
